import styled, { css } from 'styled-components'

export const LeaseStatusCell = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)

export const ResidentsCell = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    min-width: 0;
    gap: ${theme.space['12']};
  `,
)

export const TooltipTitle = styled.p(
  ({ theme }) => css`
    margin-bottom: ${theme.space['4']};
  `,
)

export const TooltipList = styled.ul(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['2']};
    padding-left: ${theme.space['12']};
    list-style: disc;
  `,
)
